import { IconProps } from "@/types/types";

export default function Clock({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.375 13.0825C10.9882 12.8592 10.75 12.4466 10.75 12V8.75C10.75 8.05965 11.3096 7.5 12 7.5C12.6904 7.5 13.25 8.05965 13.25 8.75V11.2783L15.8726 12.7925C16.4705 13.1376 16.6753 13.9021 16.3301 14.5C15.985 15.0979 15.2205 15.3027 14.6226 14.9575L11.375 13.0825Z" fill="currentColor" />
        </svg>
    )
}

